function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#3C8EFF",
  "data-override": "fill",
  fillRule: "evenodd"
}, React.createElement("rect", {
  width: 16.867,
  height: 1.687,
  rx: 0.843
}), React.createElement("rect", {
  y: 4.6,
  width: 16.867,
  height: 1.687,
  rx: 0.843
}), React.createElement("path", {
  d: "M0 10.043C0 9.578.38 9.2.843 9.2H11.42c.465 0 .843.374.843.843 0 .466-.38.844-.843.844H.843A.841.841 0 010 10.043z"
}));

const SvgMenu = ({
  svgRef,
  ...props
}) => React.createElement("svg", _extends({
  width: 17,
  height: 11,
  viewBox: "0 0 17 11",
  ref: svgRef
}, props), _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgMenu, _extends({
  svgRef: ref
}, props)));
export default ForwardRef;